import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileFloatingQuote from './MobileFloatingQuote';
import { useLocation } from 'react-router-dom';

export default function Layout({ children, hideFooter = false }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return (
    <div className="App min-h-screen bg-white text-slate-800 flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
      <MobileFloatingQuote />
    </div>
  );
}
